/* eslint-disable */
export const COLUMNS = [
  {
    value: "educatorsFullName",
    text: "Educator's name",
    isDesktop: false,
    sortable: true,
    cell: (user) => ({
      text: `${user.name.givenName} ${user.name.familyName}`,
      value: `${user.name.givenName.toLowerCase()} ${user.name.familyName.toLowerCase()}`
    })
  },
  {
    value: "username",
    text: "Username",
    onMobile: true,
    onTablet: true,
    sortable: true,
    cell: (user) => ({
      text: `${user.userName}`,
      value: `${user.userName}`
    })
  },
  {
    value: "email",
    text: "Email",
    onMobile: true,
    onTablet: true,
    sortable: true,
    cell: (user) => {
      const primaryEmailObj = user.email && user.email.find(e => e.primary);
      return primaryEmailObj 
        ? { text: primaryEmailObj.value, value: primaryEmailObj.value }
        : { text: '', value: ''};
    }
  },
  {
    value: "entitlements",
    text: "Role",
    onMobile: true,
    onTablet: true,
    sortable: true,
    cell: (user) => ({
      entitlements: user.entitlements
    })
  }
];

export const SETTINGS = {
  multiSelect: true,
  rowActions: true,
  contextAction: true
};

export const ACTIONS = [
  {
    label: "Remove",
    icon: "delete",
    action: "action:delete",
    inHeader: true,
    allowFor: ["admin"]
  }
];